module.exports = __webpack_public_path__ + "img/20200801_134351.c049a974.jpg";